import { useState, useRef } from 'react';
import Grow from '@mui/material/Grow';
import Popper from '@mui/material/Popper';
import {
  Container, TralateContainer,
  TraslateIconStyled, StyledPaper, StyledOption, ListMenu
} from './styles/TraslateStyle';
import useOnClickOutside from '../../utilities/hooks/useOnClickOutside'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux';


function TraslateComponent({ color }) {
  const [state, setState] = useState({})
  const [t, i18n] = useTranslation("global");
  const dispatch = useDispatch();


  //const getCurrentLng = () => i18n.language || window.localStorage.i18nextLng || '';
  // console.log(getCurrentLng)

  const [menuOpen, setMenuOpen] = useState(false);
  const containerRef = useRef(null);


  const handleMenuOpen = () => {
    setMenuOpen(!menuOpen);
  }

  useOnClickOutside(containerRef, () => setMenuOpen(false));


  /*const changeLanguage = (param) => {
    i18n.changeLanguage('param')

  } */

  return (
    <Container ref={containerRef} onClick={handleMenuOpen}>

      <TraslateIconStyled />



      <Popper
        open={menuOpen}
        anchorEl={containerRef.current}
        role={undefined}
        placement='bottom-end'
        transition
        disablePortal
        width='50px'
      >
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                'right top',
              color: 'red'
            }}
          >

            <StyledPaper>
              <ListMenu >
                <TralateContainer>

                  <StyledOption onClick={() => i18n.changeLanguage('es')} >Español 🇩🇴</StyledOption>
                </TralateContainer>
                <div style={{ height: '1px', backgroundColor: 'gray' }} />
                <TralateContainer>
                  <StyledOption onClick={() => i18n.changeLanguage('en')}>English 🇺🇸   </StyledOption>
                </TralateContainer>
              </ListMenu>

            </StyledPaper>
          </Grow>
        )
        }
      </Popper >
    </Container >
  );
}

export default TraslateComponent;